import React, { lazy } from "react";
import queryString from "query-string";
import PrivateRoute from "PrivateRoutes";

const KnowledgeBase = lazy(() =>
  import(
    /* webpackChunkName: "KnowledgeBase" */ "./components/KnowledgeBase"
  )
);
const KnowledgeBaseAddEdit = lazy(() =>
  import(
    /* webpackChunkName: "KnowledgeBaseAddEdit" */ "./components/KnowledgeBaseAddEdit"
  )
);

const createForm = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  return <KnowledgeBaseAddEdit mode="create" type={queryParams.type} />;
};

const editForm = ({ match }) => {
  return (
    <KnowledgeBase mode="edit" smartAgentId={match.params._id} />
  );
};

const routes = () => {
  return (
    <React.Fragment>
      <PrivateRoute
        key="/settings/knowledge-base"
        exact={true}
        path="/settings/knowledge-base"
        component={KnowledgeBase}
      />

      <PrivateRoute
        key="/settings/knowledge-base/create"
        exact={true}
        path="/settings/knowledge-base/create"
        component={createForm}
      />

      <PrivateRoute
        key="/settings/knowledge-base/edit/:_id"
        exact={true}
        path="/settings/knowledge-base/edit/:_id"
        component={editForm}
      />
    </React.Fragment>
  );
};

export default routes;


// WEBPACK FOOTER //
// src/modules/screens/settings/KnowledgeBase/routes.js